import React, { FC } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'

import { loadClientNotes, loadClientLinkedFiles } from '../../store/client'
import DetailsChecker from '../shared/DetailsChecker'
import ActiveNotesModal, { openActiveNotesModal } from './ActiveNotesModal'
import { ClientDetailsServerData } from 'src/store/client/client.types'
import { AppDispatch } from 'src/store/index.d'
import { ActiveNote, linkedFile } from './types'
const ClientChecker: FC<{
  data: ClientDetailsServerData
  children: React.ReactNode
}> = ({ data, children }) => {
  const dispatch = useDispatch<AppDispatch>()

  const { ID, hash }: { ID: number; hash: string } = useParams()

  const [activeNotes, setActiveNotes] = React.useState<ActiveNote[]>([])
  const [linkedFiles, setLinkedFiles] = React.useState<linkedFile[]>([])

  const loadData = React.useCallback(
    async (isMount = true) => {
      //@ts-ignore
      const clientNotesResult: {
        meta: any
        type: string
        payload: ActiveNote[]
      } = await dispatch(loadClientNotes({ clientId: ID, clientHash: hash }))

      if (loadClientNotes.fulfilled.match(clientNotesResult)) {
        setActiveNotes(clientNotesResult.payload)
      }

      //@ts-ignore
      const linkedFilesResult: {
        meta: any
        type: string
        payload: linkedFile[]
      } = await dispatch(loadClientLinkedFiles({ clientId: ID, clientHash: hash }))

      if (loadClientLinkedFiles.fulfilled.match(linkedFilesResult)) {
        setLinkedFiles(linkedFilesResult.payload)
      }

      if (isMount) {
        dispatch(openActiveNotesModal())
      }
    },
    [dispatch, setActiveNotes, setLinkedFiles, ID, hash],
  )

  return (
    <DetailsChecker
      shouldCheck={data.NoteCount > 0}
      doCheck={loadData}
      renderCheckResult={({
        isFetching,
        onRecheck,
        onClose,
      }: {
        isFetching: boolean
        onRecheck: () => void
        onClose: () => void
      }) => {
        return (
          <ActiveNotesModal
            fetching={isFetching}
            notes={activeNotes}
            files={linkedFiles}
            onRefresh={() => {
              setActiveNotes([])
              setLinkedFiles([])
              onRecheck()
            }}
            onClose={onClose}
          />
        )
      }}
    >
      {children}
    </DetailsChecker>
  )
}

export default React.memo(ClientChecker)
